import { useRootStore } from '@Shared/stores/root';

export const usePortalUri = () => {
  let { portalUri } = useRootStore();
  if (!portalUri) throw new Error('No portal URI');
  if (portalUri[portalUri.length - 1] == '/') portalUri = portalUri.substring(0, portalUri.length - 1);
  return portalUri;
};
